module.exports = __webpack_public_path__ + "img/first_svg-01.973fc474.svg";